import { render, staticRenderFns } from "./index.vue?vue&type=template&id=168702cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168702cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168702cc')) {
      api.createRecord('168702cc', component.options)
    } else {
      api.reload('168702cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=168702cc&scoped=true", function () {
      api.rerender('168702cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybsjhsz/index.vue"
export default component.exports